import React from 'react';
import Snackbar from '@mui/material/Snackbar'; // Correct import for Snackbar
import MuiAlert from '@mui/material/Alert';


const MUIAlert = ({ open, onClose, severity = "success", message }) => {
    const borderCol = String(severity) + ".lighter";
    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <MuiAlert variant="outlined" onClose={onClose} severity={severity}
                sx={{
                    width: '100%',
                    backgroundColor: String(severity + ".background")
                }}>
                {message}
            </MuiAlert>
        </Snackbar>
    );
};

export default MUIAlert;
